import { useContext, useCallback } from 'react';
import { useLatest } from 'ahooks';
import { fileToObject, getFileIndex } from '../utils/utils';
import { UploadStateContext } from '../context';
export const useOnSuccess = () => {
    const { setValue, onChange } = useContext(UploadStateContext);
    const onChangeRef = useLatest(onChange);
    return useCallback((response, _file, xhr) => {
        const file = fileToObject(_file, { status: 'done', xhr });
        setValue((prev) => {
            const fileIndex = getFileIndex(file, prev);
            const value = prev.map((item, index) => {
                return index === fileIndex ? file : item;
            });
            onChangeRef.current?.(value, file);
            return value;
        });
    }, [setValue, onChangeRef]);
};
